<template>
<span>
    <div class="news">
        <NewsCard v-for="(article, index) in articles" :key="article._id" :article="article" :index="index"></NewsCard>
        <div style="margin-bottom: 60px;"></div>
    </div>
</span>
</template>

<script>
import axios from 'axios'
import NewsCard from '@/components/NewsCard.vue'
export default {
    name: 'home',
    components: { NewsCard },
    data() {
        return {
            articles: []
        }
    },
    created: async function() {
        this.articles = (await axios.get('https://api.thevapequeen.com/announcements').catch(e => console.log(e))).data.reverse()
        this.articles.map(article => article.publish_date = new Date(article.publish_date))
    }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans');

.news {
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 30px;
    h1 {
        margin-bottom: 40px;
        font-family: sans-serif;
        font-weight: lighter;
    }
}

@media (min-width: 1030px) {
    .news {
        width: 90%;
        max-width: 1366px;
    }
}
</style>
